import { ObjectValues } from 'type-alias';

export const USER_LOGIN_STATUS = {
  System: 'System',
  // Active means it is a user login that is in use, but not verified
  Active: 'Active',
  // Pending means, it is active and awaiting verification
  Pending: 'Pending',
  // Verified means it is active and verified
  Verified: 'Verified',
  // Disabled means this is not active.
  Disabled: 'Disabled',
  // Bounced delivery failed to this endpoint
  Bounced: 'Bounced',
  // Complaint the user actively complained about delivery to this endpoint
  Complaint: 'Complaint',
  NotDefined: 'NotDefined',
} as const;

export type USER_LOGIN_STATUS_VALUES = ObjectValues<typeof USER_LOGIN_STATUS>;
